import { remove, pick } from "lodash"

class ActionListener {
  constructor() {
    this.listeners = []
  }

  dispatch(payload) {
    let listeners = [...this.listeners]
    listeners.forEach((l) => l.handler(payload))
  }

  addActionListener(name, callback) {
    let id = Symbol()

    this.listeners.push({
      id,
      handler: ({ action, data, details }) => {
        if (action === name) {
          callback(data, details)
        }
      },
    })

    return id
  }

  removeActionListener(actionListenerId) {
    remove(this.listeners, (l) => l.id === actionListenerId)
  }

  addActionListenerOnce(name, callback) {
    let actionListenerId = null
    actionListenerId = this.addActionListener(name, (data, details) => {
      callback(data, details)
      this.removeActionListener(actionListenerId)
    })

    return actionListenerId
  }

  addActionListenerAll(names, callback) {
    let actionListeners = names.map((name) => ({
      name: name,
      id: null,
      isResolved: false,
      data: null,
      details: null,
    }))

    let resolve = () => {
      if (reduce(actionListeners, (isResolved, l) => isResolved && l.isResolved, true) === true) {
        callback(actionListeners.map((l) => pick(l, ["name", "data", "details"])))
        actionListeners.forEach((l) => this.removeActionListener(l.id))
      }
    }

    actionListeners.forEach((l) => {
      l.id = this.addActionListener(l.name, (data, details) => {
        l.resolved = true
        l.data = data
        l.details = details

        resolve()
      })
    })
  }

  addActionListenerRace(names, callback) {
    let actionListeners = names.map((name) => ({
      name: name,
      id: null,
      isResolved: false,
      data: null,
      details: null,
    }))

    let resolve = (actionListener) => {
      callback(pick(actionListener, ["name", "data", "details"]))
      actionListeners.forEach((l) => this.removeActionListener(l.id))
    }

    actionListeners.forEach((l) => {
      l.id = this.addActionListener(l.name, (data, details) => {
        l.resolved = true
        l.data = data
        l.details = details

        resolve(l)
      })
    })
  }
}

export default ActionListener
